import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { getPlanTypeDirection } from '@app/common/src/utils/getPlanTypeDirection'
import { getPlanTypeName } from '@app/common/src/utils/getPlanTypeName'
import { isPilotPlanType } from '@app/common/src/utils/isPilotPlanType'

export interface UseSuccessfulCheckoutMessageArgs {
  currentPlanType: PlanType
  newPlanType: PlanType
}

export const useSuccessfulCheckoutMessage = ({
  currentPlanType,
  newPlanType
}: UseSuccessfulCheckoutMessageArgs): string => {
  const direction = getPlanTypeDirection(currentPlanType, newPlanType)
  const selectedPlanName = getPlanTypeName(newPlanType)

  if (isPilotPlanType(currentPlanType)) {
    return `Thanks for choosing ${selectedPlanName}`
  } else if (direction > 0) {
    return `Thanks for upgrading to ${selectedPlanName}`
  } else if (direction < 0) {
    return `You have successfully downgraded to ${selectedPlanName}`
  }
  return `You have successfully updated your ${selectedPlanName} plan`
}
